<template>
  <div class="concept-expanded">
    <p v-if="!this.concept" style="text-align: center; width: 100%; margin-top: 40px;">Fetching {{conceptName}}...</p>
    <div v-if="this.concept" class="concept-view scroll-area" :id="this.concept.id">
      <div class="identifiers can-edit">
        <div>
          <div class="number">{{ $store.state.org.numberPrefix }}-{{ numberPadded }}</div>
          <div>
            <Editable tag="h2" keyName="name" :value="this.concept.name" :conceptId="concept.id" >
            </Editable>
          </div>
          <div class="details">
            <Editable tag="p" keyName="description" :value="description" :conceptId="concept.id" >
            </Editable>
          </div>
          <div class="selects">
            <input type="radio" id="ideas" value="Ideas" v-model="viewingType">
            <label for="ideas" :class="[viewingIdeasLabelClass]"><span class="symbol symbol--is-square"></span>{{ ideaCountLabel }}</label>
            <input type="radio" id="references" value="References" v-model="viewingType">
            <label for="references" :class="[viewingReferencesLabelClass]"><span class="symbol symbol--is-circle"></span>{{ referenceCountLabel }}</label>
          </div>
        </div>
        <div>
          <details style="width: fit-content; text-align: right;">
            <summary>···</summary>
            <details>
              <summary>Delete this Concept</summary>
              <button class="delete" @click="deleteConcept">Confirm Delete</button>
            </details>
          </details>
        </div>
      </div>
      <div class="grid" v-if="viewingType == 'Ideas'">
        <div class="blocks">
          <Block
            v-for="(block, index) in this.ideaBlocks"
            v-bind:block="block"
            v-bind:index="index"
            v-bind:key="block.id"
            v-bind:inConceptId="this.concept.id"
            medium="medium"
          ></Block>
        </div>
      </div>
      <div class="grid" v-if="viewingType == 'References'">
        <div class="blocks">
          <Block
            v-for="(block, index) in this.referenceBlocks"
            v-bind:block="block"
            v-bind:index="index"
            v-bind:key="block.id"
            v-bind:inConceptId="this.concept.id"
            medium="medium"
          ></Block>
        </div>
      </div>
      <br>
      <br>
      <br>
    </div>
  </div>
</template>

<script>
import Block from '@trust/components/Block.vue'
import Editable from '@trust/components/Editable.vue'

export default {
  name: 'ConceptExpanded',
  components: {
    Block,
    Editable,
  },
  data() {
    return {
      concept: null,
      viewingType: 'Ideas',
    }
  },
  props: ['conceptSlug'],
  computed: {
    conceptBlocks(){
      let blocks = [];
      if(this.$store.state.org.blocks && this.concept){
        this.concept.blocks.forEach(blockInConcept => {
          let blockData = this.$store.state.org.blocks.find(b => b.id == blockInConcept.blockId);
          let block = {...blockInConcept, ...blockData};
          blocks.push(block);
        });

        blocks.sort(function(a, b) {
          if (a.order > b.order) return -1;
          if (a.order < b.order) return 1;
          return 0;
        });
      }

      return blocks;
    },
    ideaBlocks(){
      let ideaBlocks = this.conceptBlocks.filter(b => b.type == 'Idea')
      return ideaBlocks;
    },
    referenceBlocks(){
      return this.conceptBlocks.filter(b => b.type == 'Reference')
    },
    description(){
      return this.concept.description || "Add description"
    },
    conceptName(){
      return decodeURIComponent(this.conceptSlug);
    },
    ideaCountLabel(){
      let str = this.ideaBlocks.length + ' Idea';
      if(this.ideaBlocks.length != 1) { str += 's'}
      return str;
    },
    referenceCountLabel(){
      let str = this.referenceBlocks.length + ' Reference';
      if(this.referenceBlocks.length != 1) { str += 's'}
      return str;
    },
    viewingIdeasLabelClass(){
      if(this.viewingType == 'Ideas'){
        return 'label--is-selected';
      } else {
        return '';
      }
    },
    viewingReferencesLabelClass(){
      if(this.viewingType == 'References'){
        return 'label--is-selected';
      } else {
        return '';
      }
    },
    numberPadded(){
      let num = this.concept.number;
      return String(num).padStart(3, '0');
    }
  },
  methods: {
    deleteConcept(){
      this.$store.commit('deleteConcept', { conceptId: this.concept.id });
      this.$emit('headHome');
    },
  },
  mounted() {
    this.$store.commit('setShowNewBlockInHeader', { newValue: true });

    let viewingType = this.$store.state.routing.conceptViewingType;
    if(viewingType != null) {
      this.viewingType = viewingType;
    }

    if(this.concept){
      this.$store.commit('setViewingConcept', { conceptId: this.concept.id });
    }
  },
  created () {
    if(this.concept == null) {
      this.$store.commit('fetchBlocks');
      this.$store.commit('fetchConcepts');
    }
  },
  watch: {
    '$store.state.org.concepts' () {
      this.concept = this.$store.state.org.concepts.find(concept => {
        return concept.name.toLowerCase() == this.conceptName.toLowerCase()
      });

      this.$store.commit('setViewingConcept', { conceptId: this.concept.id });
    },
    'viewingType' (to) {
      if (to == 'References' && this.$store.state.routing.expandedBlock.blockId == null){
        let slug = this.conceptSlug;
        this.$store.dispatch('routing/goToConceptReferences', { slug }, {root: true});
      } else {
        let slug = this.conceptSlug;
        this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
      }
    }
  },
}
</script>

<style>
.concept-expanded {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
}

.concept-expanded .concept-view {
  padding: 0 40px;
  box-sizing: border-box;
}

.concept-expanded .grid {
  width: 100%;
}

.concept-expanded .grid .blocks {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
}

.concept-expanded .identifiers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 120px 12vw;
}

.concept-expanded .identifiers .number {
  font-family: 'Lettera', monospace;
  font-weight: 400;
  font-size: 16px;
  color: var(--black-900);
  text-align: left;
  margin-bottom: 16px;
}

.concept-expanded .identifiers h2 {
  margin: 0;
  line-height: 150%;
}

.concept-expanded .identifiers p {
  margin: 0;
}

.concept-expanded .details p {
  margin: 0;
  font-size: 24px;
  line-height: 150%;
}

.concept-expanded .selects {
  margin-top: 24px;
  margin-left: 2px;
}

.concept-expanded .selects .symbol {
  margin-right: 12px;
  transition: all 200ms ease-in-out;
}

.concept-expanded .selects input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  opacity: 0;
  position: fixed;
  pointer-events: none;
  background-color: #fff;
  margin: 0;
}

.concept-expanded .selects label {
  font-family: 'Lettera', monospace;
  font-weight: 400;
  color: var(--beige-450);
  margin-right: 40px;
  transition: all 200ms ease-in-out;
}

.concept-expanded .selects label:hover {
  cursor: pointer;
}

.concept-expanded .selects label.label--is-selected {
  color: var(--beige-800);
  font-weight: 500;
}

.concept-expanded .selects label.label--is-selected .symbol {
  background-color: var(--beige-800);
}


@media screen and (max-device-width: 600px) {
  .concept-expanded .concept-view {
    padding: 0 20px;
  }

  .concept-expanded .identifiers {
    margin: 40px 5vw;
  }

  .concept-expanded .selects {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
  }

  .concept-expanded .grid .blocks {
    grid-template-columns: 1fr;
  }

  .concept-expanded .concept-view.scroll-area {
    overflow-x: hidden;
  }
}

/* @media screen and (orientation:portrait) {

} */

@media screen and (max-device-width: 600px) and (orientation:landscape) {
  .concept-expanded .grid .blocks {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
